import { render, staticRenderFns } from "./VerClientes.vue?vue&type=template&id=91fa5d6a&scoped=true"
import script from "./VerClientes.vue?vue&type=script&lang=js"
export * from "./VerClientes.vue?vue&type=script&lang=js"
import style0 from "./VerClientes.vue?vue&type=style&index=0&id=91fa5d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fa5d6a",
  null
  
)

export default component.exports